import { FeedProvider, EventType } from "../commons/Constants";
import postEvent, { createBaseLanderEvent } from "../commons/LanderEvent";
import { Settings } from "../config";

export { EventType };

export interface RollerAdsEventOptions {
  bid?: number;
  campaignId?: number;
  adUrl?: string;
  errorCode?: string;
  keyword?: string;
}

export function sendRollerAdsEvent(
  eventType: string,
  landerConfig: any,
  options?: RollerAdsEventOptions
) {
  const event = createBaseLanderEvent(eventType, landerConfig);
  event.feedProvider = FeedProvider.ROLLER_ADS;

  if (options?.bid != null) {
    event.rollerAdsBid = options.bid;
  }
  if (options?.campaignId != null) {
    event.rollerAdsCampaignId = options.campaignId;
  }
  if (options?.adUrl) {
    event.rollerAdsUrl = options.adUrl;
  }
  if (options?.errorCode) {
    event.errorCode = options.errorCode;
  }
  if (options?.keyword) {
    event.rollerAdsKeyword = options.keyword;
  }

  // For AD_REDIRECT, use sendBeacon to ensure delivery before page unload
  if (eventType === EventType.AD_REDIRECT) {
    const endpoint = Settings.EVENT_PUBLISH_API;
    const blob = new Blob([JSON.stringify(event)], {
      type: "application/json",
    });
    navigator.sendBeacon(endpoint, blob);
    return;
  }

  postEvent(Settings.EVENT_PUBLISH_API, event);
}
